import React from 'react'
import styles from './aboutus.module.css'
import { Row, Col } from 'antd'
import { Typography } from 'antd';
import { graphql, useStaticQuery } from 'gatsby';

const { Text, Title } = Typography;


const About = () => {
    const data = useStaticQuery(graphql`
    query{
        allContentfulFranchisee{
      edges{
        node{
         title
          aboutUs{
            aboutUs
          }
          about4ir{
            about4ir
          }
        }
      }
    }
      }
    `)
    const title = data.allContentfulFranchisee.edges[0].node.title;
    const aboutData = data.allContentfulFranchisee.edges[0].node.aboutUs.aboutUs;
    const about4ir = data.allContentfulFranchisee.edges[0].node.about4ir.about4ir;
    console.log(aboutData);
    return (
        <div>
            <div className={styles.borders}>
                <Row justify="center">
                    <Col > <Title level={1} style={{ marginTop: '3%' }}>MISSION</Title></Col>
                </Row>
                <Row justify="center">
                    <Text type="secondary" style={{ fontSize: '20px', marginTop: '3%' }}>{title}</Text>
                </Row>
                <Row justify="center" style={{ marginTop: '5%' }}>
                    <Col > <Title level={1}>ABOUT</Title></Col>

                </Row>
                <Row justify="center">
                    <Text type="secondary" style={{ fontSize: '20px', marginTop: '3%' }}>{aboutData}</Text>
                </Row>
                <Row justify="center" style={{ marginTop: '5%' }}>
                <Col > <Title level={1}>ABOUT 4IR</Title></Col>

            </Row>
            <Row justify="center">
                <Text type="secondary" style={{ fontSize: '20px', marginTop: '3%' }}>The 4th industrial revolution is characterized by a range of new technologies that are fusing the physical, digital and biological worlds, impacting all disciplines, economies and industries, and even challenging ideas about what it means to be human. This fusion is possible by building new products using the latest advancement in technology such as artificial intelligence, robotics, automation, the internet of things, 3D printing, blockchain, cloud native, and biotechnology. The way forward is to innovate and build new products by integrating these technologies.</Text>
            </Row>
            </div>
        </div>
    )
}

export default About;